export const ERROR_MESSAGE = 'logo_maker:: Failed to fetch project ideas from buyer_ideas in search_perseus';

export const IDEAS_TAG_TYPES = {
    INDUSTRY: 'industry',
    TAG: 'tag',
    BRAND_VALUES: 'brand-values'
};
